import { lazy } from "react";
// const Friends = lazy(() => import("../pages/Friends"));
const Home = lazy(() => import("../pages/Home"));
// const Play = lazy(() => import("../pages/Play"));
const Profile = lazy(() => import("../pages/Profile"));
// const Quests = lazy(() => import("../pages/Quests"));
const Landing = lazy(() => import("../pages/Landing"));
const QRcode = lazy(() => import("../pages/QRcode"));
const QRinvite = lazy(() => import("../pages/QRinvite"));
const Newsfeed = lazy(() => import("../pages/Newsfeed"));
const Compete = lazy(() => import("../pages/Compete"));
const Treasure = lazy(() => import("../pages/Treasure"));
const SignIn = lazy(() => import("../pages/Authentication/SignIn"));
const SignUp = lazy(() => import("../pages/Authentication/SignUp"));
const TreasurePage = lazy(() => import("../pages/TreasurePage"));
const Play = lazy(() => import("../pages/Play"));
const Play2 = lazy(() => import("../pages/Play2"));
const Party = lazy(() => import("../pages/Party"));
const Signup = lazy(() => import("../pages/Signup"));
const QRValidate = lazy(() => import("../pages/QRValidate"));
const PlayQuest = lazy(() => import("../components/quest/PlayQuest"));
const PartyBuilder = lazy(() => import("../pages/PartyBuilder"));
const LeaderBoard = lazy(() => import("../pages/LeaderboardPage"));
const ChatDemo = lazy(() => import("../pages/ChatDemo"));
const CreatureFloaterPage = lazy(() => import("../pages/CreatureFloaterPage"));
const PrizeBoxDemo = lazy(() => import("../pages/PrizeBoxDemo"));
const LightBallDemo = lazy(() => import("../pages/LightBallDemo"));
const LightMeterExample = lazy(() => import("../components/LightMeterExample"));
const GameMaster = lazy(() => import("../pages/GameMaster"));
const EnhancedUserRoleDisplay = lazy(
	() => import("../components/EnhancedUserRoleDisplay")
);
const PartyManager = lazy(() => import("../pages/PartyManager"));
const RingleaderDashboard = lazy(() => import("../pages/RingleaderDashboard"));
const AcceptInvite = lazy(() => import("../pages/AcceptInvite"));
const QRValidateTest = lazy(() => import("../pages/QRValidateTest"));
const AcceptInviteTest = lazy(() => import("../pages/AcceptInviteTest"));
const JudgeOnboarding = lazy(
	() => import("../components/gamemaster/JudgeOnboarding")
);
const ComplimentPage = lazy(() => import("../pages/Compliments"));
const QuestTutorialPage = lazy(() => import("../pages/QuestTutorialPage"));
const ChooseQuest = lazy(() => import("../components/quest/ChooseQuest"));
const StarSalute = lazy(() => import("../pages/Salutes/StarSalute"));
const StarReceipt = lazy(() => import("../pages/Salutes/StarReceipt"));
const SaluteSelect = lazy(() => import("../pages/Salutes/SaluteSelect"));
const SecretSaluteRedirect = lazy(
	() => import("../pages/SecretSaluteRedirect")
);
const SecretSaluteView = lazy(() => import("../pages/SecretSaluteView"));
const Guess = lazy(() => import("../pages/Guess"));
const UserDashboard = lazy(() => import("../pages/UserDashboard"));
const Start = lazy(() => import("../pages/Story/Start"));
const Kidnap = lazy(() => import("../pages/Story/Kidnap"));
const SpaceIntercept = lazy(() => import("../pages/StoryLandingB"));
const Starfield = lazy(() => import("../pages/StoryLanding"));
const NewSignup = lazy(() => import("../components/NewSignUp"));
const InstallApp = lazy(() => import("../pages/InstallApp"));
const TransparentLoopingVideoExample = lazy(
	() => import("../components/TransparentLoopingVideoExample")
);
const TransparentLoopingVideoWhiteMaskExample = lazy(
	() => import("../components/TransparentLoopingVideoWhiteMaskExample")
);
const SpriteSheetLoaderTester = lazy(
	() => import("../components/SpriteSheetLoaderTester")
);
const SpriteSheetAnimationDemonstrator = lazy(
	() => import("../components/SpriteSheetAnimationDemonstrator")
);

const coreRoutes = [
	{ path: "/", title: "Home", component: Newsfeed },
	// { path: "/home", title: "Home", component: Home },
	{ path: "/profile", title: "Profile", component: Profile },
	{ path: "/landing", title: "Landing", component: Landing },
	{ path: "/qrcode", title: "QRcode", component: QRcode },
	{ path: "/newsfeed", title: "Newsfeed", component: Newsfeed },
	{ path: "/compete", title: "Compete", component: Compete },
	{ path: "/treasure", title: "Treasure", component: Treasure },
	{ path: "/treasure/:id", title: "Treasure", component: TreasurePage },
	{ path: "/signin", title: "Signin", component: SignIn },
	{ path: "/register", title: "Register", component: SignUp },
	{ path: "/playersignup", title: "Sign Up", component: NewSignup },
	{ path: "/install", title: "Install App", component: InstallApp },
	{ path: "/compliment", title: "Compliment", component: ComplimentPage },
	{ path: "/secret-salute", title: "Secret Salutes", component: Play2 },
	{
		path: "/secret-salute-redirect",
		title: "Secret Salutes Redirect",
		component: SecretSaluteRedirect,
	},
	{
		path: "/starsalute",
		title: "Star Salutes",
		component: StarSalute,
	},
	{
		path: "/salute-select",
		title: "Salute Select",
		component: SaluteSelect,
	},
	{ path: "/party/:id", title: "Party", component: Party },
	{ path: "/signup", title: "Signup", component: Signup },
	{ path: "/invite", title: "QR Invite", component: QRinvite },
	{ path: "/QRvalidate", title: "QR Invite", component: QRValidate },
	{
		path: "/QRvalidate/:inviteID",
		title: "QR Invite Test",
		component: QRValidateTest,
	},
	{ path: "/playquest", title: "Quests", component: PlayQuest },
	{ path: "/partybuilder", title: "Quests", component: PartyBuilder },
	{ path: "/leaderboard", title: "LeaderBoard", component: LeaderBoard },
	{
		path: "/newsfeed/:postType/:id",
		title: "Post",
		component: Newsfeed,
		props: { showPost: true },
	},
	// Fallback for old URLs without post type (will try to detect automatically)
	{
		path: "/newsfeed/:id",
		title: "Post",
		component: Newsfeed,
		props: { showPost: true },
	},
	{ path: "/chat-demo", title: "Chat Demo", component: ChatDemo },
	{
		path: "/beamkins",
		title: "Your Beamkins",
		component: CreatureFloaterPage,
	},
	{ path: "/prize-box-demo", title: "Prize Box Demo", component: PrizeBoxDemo },
	{
		path: "/lightball-demo",
		title: "LightBall Demo",
		component: LightBallDemo,
	},
	{
		path: "/lightmeter-example",
		title: "LightMeter Example",
		component: LightMeterExample,
	},
	{ path: "/gamemaster", title: "GameMaster", component: GameMaster },
	{ path: "/judging", title: "Judging", component: GameMaster },
	{
		// path: "/quest-tutorial",
		title: "Quest Tutorial",
		component: QuestTutorialPage,
	},
	{ path: "/choose-quest", title: "Choose Quest", component: ChooseQuest },
	{
		path: "/user-role-display",
		title: "User Role Display",
		component: EnhancedUserRoleDisplay,
	},
	{
		path: "/story-landing",
		title: "Story Landing",
		component: Starfield,
	},
	{
		path: "/partymanager",
		title: "Ringleader Dashboard",
		component: RingleaderDashboard,
	},
	{
		path: "/accept-invite/:partyId/:contestid?/:memberid?/:role?/:type?",
		title: "Accept Invite",
		component: AcceptInvite,
	},
	{
		path: "/accept-invite-test/:inviteID",
		title: "Accept Invite Test",
		component: AcceptInviteTest,
	},
	{
		path: "/judge-onboarding/:contestID/:gameMasterID",
		title: "Judge Onboarding",
		component: JudgeOnboarding,
	},
	{
		path: "/starsalute/view/:starID",
		title: "Star Receipt",
		component: StarReceipt,
	},
	{
		path: "/secretsalute/view/:cardID",
		title: "Secret Salute View",
		component: SecretSaluteView,
	},
	{
		path: "/takeaguess/:cardID",
		title: "Take a Guess",
		component: Guess,
	},
	{
		path: "/dashboard",
		title: "User Dashboard",
		component: UserDashboard,
	},
	{
		path: "/start",
		title: "Start",
		component: Start,
	},
	{
		path: "/kidnap",
		title: "Kidnap",
		component: Kidnap,
	},
	{
		path: "/transparent-video",
		title: "Transparent Video Demo",
		component: TransparentLoopingVideoExample,
	},
	{
		path: "/transparent-video-white-mask",
		title: "Transparent Video White Mask Demo",
		component: TransparentLoopingVideoWhiteMaskExample,
	},
	{
		path: "/testsprites",
		title: "Sprite Sheet Tester",
		component: SpriteSheetLoaderTester,
	},
	{
		path: "/beamkinanimations",
		title: "Beamkin Animations",
		component: SpriteSheetAnimationDemonstrator,
	},
];

const routes = [...coreRoutes];
export default routes;
